export default import.meta.ROLLUP_FILE_URL_$oUiuAXR7gZMKRQU56HW2w;